<template>
  <div>
    <el-dialog title="上传签收单" :visible.sync="showDialog" append-to-body width="45%" @close="onClose">
      <el-form ref="formDataRef" :model="formData" size="mini" label-width="130px" inline :rules="rules">
        <el-form-item label="装货日期" prop="proxyShippingDate">
          <el-date-picker v-model="formData.proxyShippingDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:195px"></el-date-picker>
        </el-form-item>
        <el-form-item label="装货数量" prop="proxyShippingQty">
          <el-input-number v-model="formData.proxyShippingQty" placeholder="请输入装货数量" controls-position="right" style="width:195px" />
        </el-form-item><br>
        <el-form-item label="卸货日期" prop="proxyReceiveDate">
          <el-date-picker v-model="formData.proxyReceiveDate" :picker-options="pickerOptions" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" style="width:195px"></el-date-picker>
        </el-form-item>
        <el-form-item label="卸货数量" prop="proxyReceiveQty">
          <el-input-number v-model="formData.proxyReceiveQty" placeholder="请输入卸货数量" controls-position="right" style="width:195px" />
        </el-form-item><br>
        <el-form-item label="最终联系人" prop="linkman">
          <el-input v-model="formData.linkman" placeholder="请输入最终联系人" clearable style="width:195px" />
        </el-form-item>
        <el-form-item label="最终联系人手机号" prop="linkmanPhoneNumber">
          <el-input v-model="formData.linkmanPhoneNumber" placeholder="请输入最终联系人手机号" clearable style="width:195px" />
        </el-form-item>
        <el-form-item label="交接地址" prop="handoverAddress">
          <el-input v-model="formData.handoverAddress" placeholder="请输入交接地址" type="textarea" style="width:490px" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="formData.proxyHandoverRemark" type="textarea" style="width:490px" placeholder="请输入" clearable />
        </el-form-item><br>
        <el-form-item label="装货签收单" v-if="bizType == 'TERMINATE_RENT' || bizType == 'TERMINATE_START_RENT'">
          <upload ref="upFileFrom" :height="75" :width="490" @success="uploadSuccess" @delete="onDelete"></upload>
        </el-form-item>
        <el-form-item label="卸货签收单" v-if="(['START_RENT', 'SALE', 'ADJUST', 'TERMINATE_START_RENT'].includes(bizType))||goodsName">
          <upload ref="upFileTo" :height="75" :width="490" @success="uploadSuccessTo" @delete="onDeleteTo"></upload>
        </el-form-item>

      </el-form>
      <template #footer>
        <el-button @click="onClose" size="mini">取消</el-button>
        <el-button type="primary" @click="onSubmit" size="mini">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import upload from "_c/upload/upload.vue";

export default {
  components: { upload },
  data() {
    return {
      goodsName: "",
      showDialog: false,
      isTransferStartRent: "", //收货方是起租
      isTransferTerminateRent: "",
      isTransferSale_TO: "",
      formData: {
        logisticSubTaskId: "",
        proxyShippingDate: "",
        proxyShippingQty: undefined,
        proxyReceiveDate: "",
        proxyReceiveQty: undefined,
        proxyHandoverRemark: "",
        shippingFileIds: [],
        receiveFileIds: [],
        handoverAddress: "",
        linkmanPhoneNumber: "",
        linkman: ""
      },
      bizType: "",
      rules: {
        proxyShippingDate: [{ required: true, message: "请选择" }],
        proxyShippingQty: [{ required: true, message: "请输入" }],
        proxyReceiveDate: [{ required: true, message: "请选择" }],
        proxyReceiveQty: [{ required: true, message: "请输入" }]
      },
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() >= new Date().getTime();
        }
      }
    };
  },
  methods: {
    openDialog(row) {
      this.goodsName = row.goodsName ? row.goodsName : "";
      this.bizType = row.bizType;
      this.formData.logisticSubTaskId = row.logisticSubTaskId;
      this.isTransferStartRent = row.isTransferStartRent;
      this.isTransferTerminateRent = row.isTransferTerminateRent;
      this.isTransferSale_TO = row.isTransferSale_TO;
      this.showDialog = true;
    },
    // 上传成功
    uploadSuccess(params) {
      this.formData.shippingFileIds.push(params.body);
    },
    // 附件删除
    onDelete({ id }) {
      this.formData.shippingFileIds = this.formData.shippingFileIds.filter((item) => item != id);
    },
    // 上传成功
    uploadSuccessTo(params) {
      this.formData.receiveFileIds.push(params.body);
    },
    // 附件删除
    onDeleteTo({ id }) {
      this.formData.receiveFileIds = this.formData.receiveFileIds.filter((item) => item != id);
    },
    onClose() {
      this.showDialog = false;
      this.goodsName = "";
      this.$refs["formDataRef"].resetFields();
    },
    async onSubmit() {
      let validate = await this.$refs["formDataRef"].validate();
      if (!validate) return;

      let url = "http://MID-OPERATE-LOGISTICS/messageService/carrierProxyService/updateLogisticsSubTaskHandoverMessage";

      if (!this.formData.receiveFileIds.length) this.formData.receiveFileIds = [];
      if (!this.formData.shippingFileIds.length) this.formData.shippingFileIds = [];

      this.cfmInvoke(url, this.formData).then((rs) => {
        if (this.bizType == "TERMINATE_RENT" || this.bizType == "TERMINATE_START_RENT") {
          this.$refs.upFileFrom.$refs.uploadFile.clearFiles();
        }
        if (["START_RENT", "SALE", "ADJUST", "TERMINATE_START_RENT"].includes(this.bizType)) {
          this.$refs.upFileTo.$refs.uploadFile.clearFiles();
        }
        this.$message.success("操作成功");

        this.$refs["formDataRef"].resetFields();
        this.formData.proxyHandoverRemark = "";
        this.formData.shippingFileIds = [];
        this.formData.receiveFileIds = [];
        this.$emit("onFinish");
        this.showDialog = false;
      });
    }
  }
};
</script>